import { createContext, ReactNode, useContext, useMemo } from 'react';

import { Configuration } from './model';
import { paymentMethodConfigurationProvider } from './paymentMethodConfiguration';
import { platformConfigurationRegistry } from './platformConfiguration';

const ConfigurationContext = createContext<Configuration>({
  ...platformConfigurationRegistry.getDefault('v2'),
  ...paymentMethodConfigurationProvider.getDefault(),
});

//@TODO: implement submitInitiator as configuration condition
interface UIConfigurationProviderProps {
  themeId: string | null;
  version: 'v2' | 'v3' | 'v4';
  paymentMethodId: string | null;
  children: ReactNode;
}

export const UIConfigurationProvider = ({
  themeId,
  version,
  paymentMethodId,
  children,
}: UIConfigurationProviderProps) => {
  const configuration = useMemo(() => {
    const platformConfiguration = themeId
      ? platformConfigurationRegistry.get(themeId, version)
      : platformConfigurationRegistry.getDefault(version);

    const paymentMethodConfiguration = paymentMethodId
      ? paymentMethodConfigurationProvider.get(paymentMethodId)
      : paymentMethodConfigurationProvider.getDefault();

    return {
      ...platformConfiguration,
      ...paymentMethodConfiguration,
    };
  }, [themeId, version, paymentMethodId]);

  return (
    <ConfigurationContext.Provider value={configuration}>
      {children}
    </ConfigurationContext.Provider>
  );
};
export const useUIConfigurationContext = () => useContext(ConfigurationContext);
